module.exports = __webpack_public_path__ + "h5/img/Chloe.e9a07e9f.jpg";